export const testimonials = [
  {
    id: 1,
    quote: "Secure2Ware installed a full 16-camera surveillance system across our retail locations in under two days. The image quality is incredible, and their team walked us through the entire monitoring setup. Couldn't be happier.",
    name: "Marcus Johnson",
    title: "Operations Director",
    company: "CityStar Retail Group",
    industry: "Retail",
    rating: 5,
  },
  {
    id: 2,
    quote: "We needed access control and CCTV for our medical office building fast. Secure2Ware came out the next day, completed everything professionally, and even tied it into our existing alarm system. Highly recommend.",
    name: "Dr. Linda Torres",
    title: "Practice Manager",
    company: "Metro Health Associates",
    industry: "Healthcare",
    rating: 5,
  },
  {
    id: 3,
    quote: "Had Secure2Ware install smart home automation and security cameras throughout our new home. They handled everything from doorbell cameras to full interior/exterior coverage. The app-based control is seamless.",
    name: "Brian & Kelly Owens",
    title: "Homeowners",
    company: "Residential Client",
    industry: "Residential",
    rating: 5,
  },
  {
    id: 4,
    quote: "Our warehouse needed a serious security upgrade. Secure2Ware designed a custom system with PTZ cameras, motion sensors, and remote monitoring. Response time was 12 minutes when an alarm triggered — impressive.",
    name: "Sandra Reyes",
    title: "Warehouse Manager",
    company: "Pacific Freight Solutions",
    industry: "Logistics",
    rating: 5,
  },
  {
    id: 5,
    quote: "The access control system they installed has completely changed how we manage building entry for our law firm. Key fobs, pin codes, and audit logs for every door. Professional installation, clean wiring, excellent support.",
    name: "Thomas Albright",
    title: "Managing Partner",
    company: "Albright & Cole Law",
    industry: "Legal",
    rating: 5,
  },
  {
    id: 6,
    quote: "From quote to full installation of our 24-camera system took only 3 days. Their technicians were professional, explained everything clearly, and the remote monitoring app lets me check any camera instantly from my phone.",
    name: "Maria Castellano",
    title: "Owner",
    company: "Castellano Restaurant Group",
    industry: "Hospitality",
    rating: 5,
  },
];

export const trustBadges = [
  { id: 1, icon: "ri-shield-check-fill", label: "Licensed & Insured" },
  { id: 2, icon: "ri-award-fill", label: "10-Year Warranty" },
  { id: 3, icon: "ri-home-fill", label: "Residential & Commercial" },
  { id: 4, icon: "ri-camera-fill", label: "Hikvision Certified" },
  { id: 5, icon: "ri-tools-fill", label: "Professional Installation" },
  { id: 6, icon: "ri-verified-badge-fill", label: "Axis Partner" },
  { id: 7, icon: "ri-phone-fill", label: "Same-Day Service" },
  { id: 8, icon: "ri-global-fill", label: "Nationwide Coverage" },
  { id: 9, icon: "ri-star-fill", label: "500+ Installs Completed" },
  { id: 10, icon: "ri-time-fill", label: "24/7 Support Line" },
];

export const whyChooseUsFeatures = [
  {
    icon: "ri-camera-3-fill",
    title: "Expert Installation Team",
    description: "Licensed, background-checked technicians with 10+ years installing security systems in homes and businesses.",
  },
  {
    icon: "ri-tools-fill",
    title: "Same-Day Installation",
    description: "Most systems installed within 24 hours of your call. We respect your time and your security.",
  },
  {
    icon: "ri-shield-star-fill",
    title: "Licensed & Fully Insured",
    description: "Fully licensed, bonded, and insured. Every install meets local code and industry best practices.",
  },
  {
    icon: "ri-customer-service-2-fill",
    title: "24/7 Monitoring & Support",
    description: "Optional round-the-clock professional monitoring with instant alert response for any security event.",
  },
  {
    icon: "ri-home-smart-fill",
    title: "Residential & Commercial",
    description: "Custom systems for homes, small businesses, warehouses, retail stores, offices, and multi-site properties.",
  },
  {
    icon: "ri-price-tag-3-fill",
    title: "Transparent Flat Pricing",
    description: "No hidden fees, no surprises. Upfront quotes before every installation — guaranteed.",
  },
];

export const serviceAreas = [
  "New York, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX",
  "Phoenix, AZ", "Philadelphia, PA", "San Antonio, TX", "San Diego, CA",
  "Dallas, TX", "San Jose, CA", "Austin, TX", "Jacksonville, FL",
  "Fort Worth, TX", "Columbus, OH", "Charlotte, NC", "Indianapolis, IN",
  "San Francisco, CA", "Seattle, WA", "Denver, CO", "Nashville, TN",
  "Atlanta, GA", "Miami, FL", "Boston, MA", "Portland, OR",
];
